import React from 'react'

const AboutWhoWeAre = () => {
  return (
    <section className="who-we-are py-5">
    <div className="container-fluid px-md-5">
      <div className="row align-items-center">
        <div className="col-md-6 mb-4">
          <img
            src="assets/about.jpg"
            alt="About"
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6">
          <h2 className="fw-bold mb-3">Who We Are</h2>
          <p className="text-muted">
          We are a leading e-commerce platform committed to providing customers with top-quality products from trusted brands all over the world. Our mission is to make online shopping not only convenient, but also reliable, secure, and enjoyable for everyone.
          </p>
          <p className="text-muted">
          With years of experience in the digital marketplace, we have built a reputation for delivering exceptional value through a wide selection of products, competitive pricing, and outstanding customer service. Whether you are looking for the latest tech gadgets, home essentials, or lifestyle accessories, we strive to bring everything you need right to your fingertips.
          </p>
          <p className="text-muted">
          At the heart of our business is a passionate team that works tirelessly to ensure every order is processed smoothly, every product meets the highest standards, and every customer feels valued. We believe that shopping is more than just buying—it’s about trust, satisfaction, and creating lasting connections with our customers.              </p>
        </div>
      </div>
    </div>
  </section>
    )
}

export default AboutWhoWeAre